const socials = {
  facebook: 'fb',
  spotify: 'spot',
  instagram: 'ins',
  youtube: 'yt',
  twitter: 'tw',
  envelope: 'email', // Email
  globe: 'email' // Website
};

export default socials;



// WEBPACK FOOTER //
// ./src/constants/socials.js